import React from "react";
import Wait from "../../wait";
import CollectService from "../../../service/v1/collect";
import GeneralSelect from "../../general_select";


export default class MonitoringZonalPane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title: '',
            forms: [],
            form_fields: [],
            localityOption: {
                endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id') ,
                value: 'id',
                label: 'name',
                placeholder: 'Select ...'
            },
            regionOption: {
                endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id') ,
                value: 'id',
                label: 'name',
                placeholder: 'Select Region'
            },
            is_district_disabled: true
        }

        this.loadQuestions = this.loadQuestions.bind(this)
        this.showFormFieldsAt = this.showFormFieldsAt.bind(this)
        this.saveAnswerAt = this.saveAnswerAt.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.handleChangeFile = this.handleChangeFile.bind(this)
        this.generalSelect = this.generalSelect.bind(this)

    }

    handleChanges = (e) => {
        this.setState({[e.target.name]: e.target.value})
    }
    handleChangeFile = e => {
        this.setState({file: e.target.files[0]})
    }

    loadQuestions(id, i = 0, j = 0) {
        try {
            Wait.show('Fetching Forms........')
            document.getElementById('tr_answer').style.visibility = 'visible'
            CollectService.fetchQuestionsMonitoringForms(parseInt(id), 0).then(r => {
                try {
                    Wait.dismiss()
                    console.log(r.data.results[i].form_fields)
                    this.setState({
                        title: r.data.results[i].name,
                        forms: r.data.results,
                        form_fields: r.data.results[i].form_fields,
                        current_menu: i,
                        current_tab: j
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
            Wait.dismiss()
        }

    }

    showFormFieldsAt(i) {
        this.setState({
            title: this.state.forms[i].name,
            form_fields: this.state.forms[i].form_fields,
            current_menu: i
        })
    }


    saveAnswerAt(e, d) {
        let value = e.target.value

        if (value.toLowerCase().includes('ingine')) {
            let child = document.getElementById('tr_' + d.id)
            child.style.background = '#fcc'
            child.style.display = 'table-row'
        } else {
            try {
                document.getElementById('tr_' + d.id).style.display = 'none'
            } catch (e) {
            }
        }

        let claim_no = ''
        //project
        //para_surveyor
        let locality = ''
        let response = e.target.value
        let local_answer_date = ''

        if (e.target.type === 'file') {
            this.setState({file: e.target.files[0]})
        } else {
            try {
                CollectService.createAnswer({
                    project_id: this.props.project.id,
                    claim_no: this.props.uuid,
                    form_field_id: d.id,
                    response: response
                }).then(r => {
                    console.log(r.data)
                })
            } catch (e) {
                console.log(e)
            }
        }

        /*const formData = new FormData()
        formData.append('file',this.state.file)
        formData.append('extra',JSON.stringify({
            project_id:this.props.project.id,
            task_id:this.props.task_id,
            screen_code:this.props.screen_code
        }))*/

        console.log(d)
    }

    generalSelect(data, name) {
        this.setState({
            [name]: data
        })
        let ids = []

        switch (name) {
            case 'region':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_district_disabled: false,
                    localityOption: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('district_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select ...'
                    }
                })
                break
            case 'council':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    localityOption: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('ward_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select ...'
                    }
                })
                break
            case 'ward':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    localityOption: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('village_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select ...'
                    }
                })
                break

        }
        console.log(data)
    }

    render() {
        return (<div>
            <div className={'row'}>
                <div>

                    {this.props.questionnaires.map((d, i) => {
                        console.log(d)
                        return (<div key={i} className={i === this.state.current_tab ? 'tab tab-active' : 'tab'}
                                     style={{width: '300px'}}
                                     onClick={() => this.loadQuestions(d.id, 0, i)}>
                            {d.name}
                        </div>)
                    })}

                    {/*<select style={{width:'100%',fontWeight:'bold',fontSize:'18px'}} >
                        <option>-Choose Questionnaire-</option>

                    </select>*/}
                </div>
            </div>

            <div className={'row'} style={{fontSize: '20px', visibility: 'hidden'}} id={'tr_answer'}>
                <div className={'col col-sm-3'} style={{borderRight: '1px dashed #ccc', padding: 0}}>
                    <div style={{background: 'linear-gradient(#fff,#ccc)', padding: '8px'}}>
                        <span className={'fa fa-question-circle'}/>Questions
                    </div>
                    <br/>

                    {this.state.forms.map((d, i) => {
                        return (<div onClick={() => this.showFormFieldsAt(i)}
                                     className={i === this.state.current_menu ? 'btn-left-menu btn-left-menu-active' : 'btn-left-menu'}
                                     key={i}>{d.name}</div>)
                    })}
                </div>
                <div className={'col col-sm-9'}>

                    <div
                        style={{background: 'linear-gradient(#fff,#ccc)', borderTop: '1px solid #ccc', padding: '8px'}}>
                        <span className={'fa fa-question-circle-o'}/>{this.state.title} - {this.props.villagename}
                    </div>

                    <div style={{overflowY: 'auto', height: '75vh', padding: '24px', border: '1px solid #ccc'}}>

                        <table style={{width: '100%', marginTop: '8px'}}>
                            <tbody>
                            {this.state.form_fields.map((d, i) => {
                                return (<tr id={'tr_' + d.parent} key={'tr_' + d.form_field + '_' + d.parent}
                                            style={{display: d.parent !== 0 ? 'none' : 'table-row'}}>
                                    <td style={{
                                        width: '300px',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}>{d.form_field}</td>
                                    <td style={{fontSize: '18px'}}>
                                        <div style={{color: '#888'}}> {d.hint}</div>


                                        {d.data_type === 'select' || d.data_type === 'radio' ?
                                            <select style={{width: '91%'}} name={d.form_field}
                                                    onChange={(e) => this.saveAnswerAt(e, d)}>
                                                <option>- Choose One -</option>
                                                {d.options.split(',').map((o, j) => {
                                                    return (<option key={j}>{o}</option>)
                                                })}
                                            </select> :
                                            d.data_type === 'hamlet' ||
                                            d.data_type === 'village' ||
                                            d.data_type === 'ward' ||
                                            d.data_type === 'council' ?/*<select style={{width:'91%'}} name={d.form_field} onChange={(e)=>this.saveAnswerAt(e,d)}>
                                                <option>- Choose {d.form_field} -</option>
                                                <option value={1}>Sample {d.form_field}</option>
                                            </select>*/

                                                <GeneralSelect onChanges={(e) => this.generalSelect(e, d.data_type)}
                                                               parameters={this.state.localityOption} isDisable={this.state.is_district_disabled}/>

                                                :
                                                d.data_type === 'region' ?
                                                    <GeneralSelect onChanges={(e) => this.generalSelect(e, d.data_type)}
                                                                   parameters={this.state.regionOption}/>
                                                    :
                                                    d.data_type === 'text_large' ?
                                                        <textarea rows={6} style={{width: '90%'}}
                                                                  onChange={(e) => this.saveAnswerAt(e, d)}/> :
                                                        d.data_type === 'team_member' ? <GeneralSelect
                                                                onChanges={(e) => this.generalSelect(e, 'team_member')}
                                                                parameters={this.state.zoneOptions}/> :
                                                            <input type={d.data_type} key={d.form_field}
                                                                   style={{width: '90%'}} placeholder={d.data_type}
                                                                   name={d.form_field}
                                                                   onChange={(e) => this.saveAnswerAt(e, d)}/>
                                        }
                                        <div style={{color:'#f00'}}> {d.error_message}</div>
                                    </td>
                                </tr>)
                            })}
                            <tr>
                                <td/>
                                <td>
                                    <button className={'btn'} onClick={() => this.props.loadData()}>
                                        <span className={'fa fa-save'}/>Submit
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                    </div>

                </div>

            </div>

        </div>);
    }


}















